import { render, staticRenderFns } from "./EvaluationReportToken.vue?vue&type=template&id=3c4a72f9&scoped=true&"
import script from "./EvaluationReportToken.vue?vue&type=script&lang=js&"
export * from "./EvaluationReportToken.vue?vue&type=script&lang=js&"
import style0 from "./EvaluationReportToken.vue?vue&type=style&index=0&id=3c4a72f9&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c4a72f9",
  null
  
)

export default component.exports